import { Typography, useTheme } from "@mui/material";

interface SeparatorProps {
  text: string;
  withLine?: boolean;
  headline?: boolean;
}

const Separator = ({ text, withLine, headline }: SeparatorProps) => {
  const theme = useTheme();
  if (text.length === 0) {
    return null;
  }
  return (
    <Typography
      variant={headline ? "h6" : "subtitle1"}
      sx={withLine ? { borderBottomStyle: "solid", borderBottomWidth: 1, borderColor: theme.palette.divider } : {}}
    >
      {text}
    </Typography>
  );
};

export default Separator;
